import React from 'react';
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PageWithCard from '../../components/infrastructure/PageWithCard';
import TableWithHeadingAndGlobalSearch from '../../components/Table/TableWithHeadingAndGlobalSearch';
import _ from 'lodash';
import { useCallback } from 'react';
import { useEffect } from 'react';
import { Edit2, Trash, Globe, Clock } from 'react-feather';
import { useState } from 'react';
import PaginationClassic from '../../components/pagination/PaginationClassic';
import {
    convertToBill,
    fetchPurchaseOrder,
    fetchPurchaseOrders,
    getPurchaseOrder,
} from '../../app/reducers/PurchaseOrder/purchaseOrderSlice';
import EditPurchaseModal from './EditPurchaseModal';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import { ClipLoader, ClockLoader } from 'react-spinners';
import moment from 'moment';
import { useFormik } from 'formik';
import FormikSelectGroup from '../../components/formik/FormikSelectGroup';
import { generateOptions } from '../../utils/Utils';
import { Link } from 'react-router-dom';
import EditMenu from '../../components/DropdownEditMenu/DropdownEditMenu';
import axios from 'axios';
import { toast } from 'react-toastify';
import { customIDs } from '../../utils/customIds';
import EditDateModal from '../SplitQuarterData/EditDateModal';
import AttachmentModal from './AttachmentModal';
import PrimaryBadge from '../../components/infrastructure/Badges/PrimaryBadge';
import QueryString from 'qs';
import { authAxiosInstance } from '../../utils/axiosConfig';
import { openReminderPopUp } from '../../app/reducers/ReminderPopUp/reminderPopUpSlice';
import AdvanceSearchModal from './AdvanceSearchModal';
import PhoneIconBox from '../../components/infrastructure/PhoneIconBox';
import PhoneIconBoxWithBuyer from '../../components/infrastructure/PhoneIconBoxWithBuyer';
import SecondaryButton from '../../components/infrastructure/Buttons/SecondaryButton';
import ViewQuarterlyBrokerageModal from './ViewQuarterlyBrokerageModal';
import { fetchContacts } from '../../app/reducers/Contacts/contactsSlice';

const ViewPurchaseOrder = () => {
    const [page, setPage] = useState(1);
    const [viewPurchaseModal, setPurchaseModal] = useState(false);
    const [viewAttachmentModal, setAttachmentModal] = useState(false);
    const [attachmentData, setAttachmentData] = useState(false);
    const [editData, setEditData] = useState({});
    const [spitModal, setSplitModal] = useState(false);
    const [editDateModalOpen, setEditDateModalOpen] = useState(false);
    const [editPoId, setEditPoId] = useState(null);
    const [loadingReminder, setLoadingReminder] = useState(false);
    const [showQuarterlyBrokerageModal, setShowQuarterlyBrokerageModal] = useState(false);
    const [showAdvanceSearch, setShowAdvanceSearch] = useState(false);
    const [payloadData, setPayloadData] = useState(null);
    const [advanceSearchData, setAdvanceSearchData] = useState({
        reset: true,
        data: {},
        hasMore: false,
    });
    const organization_id = process.env.REACT_APP_ZOHO_ORGANIZATION_ID;
    const dispatch = useDispatch();

    const poStatusStyle = (status) => {
        if (status === 'billed') {
            return 'bg-gray-200 border-b-2 border-white';
        } else if (status == 'cancelled') {
            return 'bg-red-200 border-b-2 border-white';
        }
    };

    const { purchaseOrder, loading } = useSelector(getPurchaseOrder); // created on 16-11-22

    const purchaseOrdersData = useMemo(
        () =>
            purchaseOrder?.purchaseorders
                ? purchaseOrder.purchaseorders.map((d) => ({
                      ...d,
                      className: poStatusStyle(d.status),
                  }))
                : [],
        [purchaseOrder]
    );

    const purchaseOrderPageContext = useMemo(
        () => (purchaseOrder?.page_context ? purchaseOrder.page_context : []),
        [purchaseOrder]
    );

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            search: 'vendor',
        },
    });

    // const convertBill = async (data) => {
    //     setButtonId(data.purchaseorder_id)
    //     dispatch(convertToBill({ id: data.purchaseorder_id}))
    //     dispatch(fetchPurchaseOrders({ page: page,status:'open' }))
    // }
    const { purchaseOrderLoading } = useSelector(getPurchaseOrder);

    useEffect(() => {
        dispatch(fetchPurchaseOrders({ page: page, status: 'open' }));
    }, [page]);

    // const waModified = async (row) => {
    //     const action = await dispatch(
    //         fetchPurchaseOrder({ id: row.purchaseorder_id })
    //     );
    //     if (action.payload?.purchaseorder) {
    //         const vendorCheck = await axios.get(
    //             `https://app2.com.bot/webhook/64426c1ee8367610b8888513?contact_type=vendor&po_id=${row.purchaseorder_id}&org_id=${organization_id}&contact_id=${row.vendor_id}&delivery_date=${row.delivery_date}`
    //         );
    //         const customerCheck = await axios.get(
    //             `https://app2.com.bot/webhook/641a5e12a52b8e34db70b32c?contact_type=customer&po_id=${row.purchaseorder_id}&org_id=${organization_id}&contact_id=${action.payload.purchaseorder.delivery_customer_id}&delivery_date=${row.delivery_date}`
    //         );
    //         if (vendorCheck?.data?.accepted) {
    //             toast.success('Vendor True');
    //         } else {
    //             toast.error('Not accepted try again');
    //         }
    //         if (customerCheck?.data?.accepted) {
    //             toast.success('Customer True');
    //         } else {
    //             toast.error('Not accepted try again');
    //         }
    //     } else {
    //         toast.error('Something Went Wrong.Please try again');
    //     }
    // };
    const waModified = async (row) => {
    const action = await dispatch(
        fetchPurchaseOrder({ id: row.purchaseorder_id })
    );

    if (!action.payload?.purchaseorder) {
        toast.error('Something Went Wrong. Please try again');
        return;
    }

    const po = action.payload.purchaseorder;
    const vendorUrl = `https://app2.com.bot/webhook/64426c1ee8367610b8888513?contact_type=vendor&po_id=${row.purchaseorder_id}&org_id=${organization_id}&contact_id=${row.vendor_id}&delivery_date=${row.delivery_date}`;
    const customerUrl = `https://app2.com.bot/webhook/641a5e12a52b8e34db70b32c?contact_type=customer&po_id=${row.purchaseorder_id}&org_id=${organization_id}&contact_id=${po.delivery_customer_id}&delivery_date=${row.delivery_date}`;

    try {
        const [vendorCheck, customerCheck] = await Promise.all([
            axios.get(vendorUrl),
            axios.get(customerUrl),
        ]);

        console.log('Vendor Check:', vendorCheck.data);
        console.log('Customer Check:', customerCheck.data);

        if (vendorCheck?.data?.accepted) {
            toast.success('Vendor True');
        } else {
            toast.error('Vendor Not accepted');
        }

        if (customerCheck?.data?.accepted) {
            toast.success('Customer True');
        } else {
            toast.error('Customer Not accepted');
        }
    } catch (err) {
        console.error('API call failed:', err);
        toast.error('Something Went Wrong with API calls.');
    }
};


    const deliveryConfirmation = async (row) => {
        const action = await dispatch(
            fetchPurchaseOrder({ id: row.purchaseorder_id })
        );
        if (action.payload?.purchaseorder) {
            const deliveryCheck = await axios.get(
                `https://app2.com.bot/webhook/650d9ca96b779408deaa621a?vendor_id=${row.vendor_id}&customer_id=${action.payload.purchaseorder.delivery_customer_id}&po_id=${row.purchaseorder_id}`
            );
            if (deliveryCheck.data?.accepted) {
                toast.success('Delivery Confirmation :True');
            } else {
                toast.error('Not accepted try again');
            }
        } else {
            toast.error('Something Went Wrong.Please try again');
        }
    };

    const sendChallan = async (row) => {
        const action = await dispatch(
            fetchPurchaseOrder({ id: row.purchaseorder_id })
        );
        if (action.payload?.purchaseorder) {
            const sendChallanCheck = await axios.get(
                `https://app2.com.bot/webhook/644611a7e8367610b8b08c19?vendor_id=${row.vendor_id}&customer_id=${action.payload.purchaseorder.delivery_customer_id}&po_id=${row.purchaseorder_id}`
            );
            if (sendChallanCheck.data?.accepted) {
                toast.success('Delivery Confiramtion :True');
            } else {
                toast.error('Not accepted try again');
            }
        } else {
            toast.error('Something Went Wrong.Please try again');
        }
    };
    const sendAddressToVendor = async (row) => {
        const action = await dispatch(
            fetchPurchaseOrder({ id: row.purchaseorder_id })
        );
        if (action.payload?.purchaseorder) {
            const sendAddressCheck = await axios.get(
                `https://app2.com.bot/webhook/64426e2ce8367610b8889fe6?vendor_id=${row.vendor_id}&customer_id=${action.payload.purchaseorder.delivery_customer_id}&po_id=${row.purchaseorder_id}`
            );
            if (sendAddressCheck.data?.accepted) {
                toast.success('Send Address Vendor Success');
            } else {
                toast.error('Not accepted try again');
            }
        } else {
            toast.error('Something Went Wrong.Please try again');
        }
    };

    const handleHelp = async(row)=>{
        const resp = await axios.get(
            `https://webhooks.com.bot/webhook/65c06258e0878c22d58d9d4c?vendor=${row?.vendor_id}`
        )        
        if(resp?.data?.accepted){
            toast.success('Help get')
        } else {
            toast.error('Fail to get help')
        }
    }

    const handleMergeAndSendToVendor = async(row)=>{
        const action = await dispatch(
            fetchPurchaseOrder({ id: row.purchaseorder_id })
        );
        
        try {
            const payload = {
            purchaseorder_number:row?.purchaseorder_number,
            delivery_customer_id: action.payload.purchaseorder.delivery_customer_id,
            purchaseorder_id:row?.purchaseorder_id,
            vendor_id:row?.vendor_id,
            receiver : 'vendor',
            quality_name:row?.cf_quality_name,
            vendor_name:row?.vendor_name,
            customer_name:action.payload.purchaseorder.delivery_customer_name,
            }
          

            const resp = await axios.post(`https://app2.com.bot/webhook/658918ecb1f3fea0bf4d575f`, payload);
            
            if(resp?.data?.accepted){
                toast.success('Merge and send to vendor successfully')
            }
            
        } catch (error) {
            console.log('Error in merge and send to vendor',error)            
        }
    }

    const handleMergeAndSendToCustomer = async(row)=>{
        const action = await dispatch(
            fetchPurchaseOrder({ id: row.purchaseorder_id })
        );
        try {
            const payload = {
            purchaseorder_number:row?.purchaseorder_number,
            delivery_customer_id:action.payload.purchaseorder.delivery_customer_id,
            purchaseorder_id:row?.purchaseorder_id,
            vendor_id:row?.vendor_id,
            receiver : 'customer',
            quality_name:row?.cf_quality_name,
            vendor_name:row?.vendor_name,
            customer_name:action.payload.purchaseorder.delivery_customer_name,
            }

            const resp = await axios.post(`https://app2.com.bot/webhook/658918ecb1f3fea0bf4d575f`, payload);
            
            if(resp?.data?.accepted){
                toast.success('Merge and send to customer successfully')
            }
            
        } catch (error) {
            console.log('Error in merge and send to vendor',error)            
        }
    }

    const handelMergeAttachments = async(row)=>{
        try {
            const payload = {
                purchaseorder_id : row?.purchaseorder_id,
                count : 2
            }

            const resp = await axios.post(
                `https://webhooks.com.bot/webhook/6596a2a94ff26267125b8668`, payload
            ) 
            if(resp?.data?.accepted){
                toast.success('Merge attachments successfully')
            } else {
                toast.error('Failed')
            }
            
        } catch (error) {
            console.log('Error', error)
        }
    } 

    const handleBuyMore = async(row)=>{
        const action = await dispatch(
            fetchPurchaseOrder({ id: row.purchaseorder_id })
        );
        if(action.payload.purchaseorder){
            const resp = await axios.get(
                `https://webhooks.com.bot/webhook/65f52728e42994a69ed770aa?vendor=${action.payload.purchaseorder.delivery_customer_id}`
            )
            if(resp?.data?.accepted){
                toast.success('Successfully')
            } else {
                toast.error('Failed')
            }
        } else { 
            toast.error('Customer not found')
        }
    }

    const handleDoubt = async(row)=>{
        const action = await dispatch(
            fetchPurchaseOrder({ id: row.purchaseorder_id })
        );
        if(action.payload.purchaseorder){
            const resp = await axios.get(
                `https://webhooks.com.bot/webhook/65f52855e42994a69ed7764d?vendor=${action.payload.purchaseorder.delivery_customer_id}`
            )
            if(resp?.data?.accepted){
                toast.success('Successfully')
            } else {
                toast.error('Failed')
            }
        } else { 
            toast.error('Customer not found')
        }
    }

    const cols = [
        {
            Header: 'Action',
            Cell: ({ row, data }) => {
                return (
                    <div
                        className="flex items-center gap-2"
                        onClick={(e) => {
                            e.stopPropagation();
                        }}
                    >
                        <Edit2
                            color="blue"
                            className="cursor-pointer"
                            onClick={() => {
                                console.log(row);
                                setPurchaseModal(true);
                                setEditData({
                                    id: row.original.purchaseorder_id,
                                    page: page,
                                });
                            }}
                        />

                        {loadingReminder == row.original.purchaseorder_id ? (
                            <ClockLoader size={25} speedMultiplier={2} />
                        ) : (
                            <button
                                onClick={async (e) => {
                                    e.stopPropagation();
                                    setLoadingReminder(
                                        row.original.purchaseorder_id
                                    );
                                    let popUpData = { ...row.original };
                                    console.log(row.original, 'check data');
                                    //Vendor Mobile No.
                                    const data = {
                                        id: row.original?.vendor_id,
                                    };
                                    const string = QueryString.stringify(data);
                                    const contacts =
                                        await authAxiosInstance.get(
                                            `purchase-orders/contacts/${data.id}?${string}`
                                        );
                                    if (contacts?.data?.data) {
                                        popUpData['vendorMobileNo'] =
                                            contacts?.data?.data?.contact?.contact_persons?.[0]?.mobile;
                                    }
                                    //Customer Mobile No.
                                    const customerData = {
                                        search: row.original?.cf_buyer_name,
                                    };
                                    const customerString =
                                        QueryString.stringify(customerData);
                                    const customerContacts =
                                        await authAxiosInstance.get(
                                            `purchase-orders/contacts?${customerString}`
                                        );
                                    console.log(customerContacts, 'new');
                                    if (customerContacts?.data?.data) {
                                        popUpData['customerMobileNo'] =
                                            customerContacts?.data?.data?.contacts?.[0]?.mobile;
                                    }
                                    dispatch(
                                        openReminderPopUp({
                                            isOpen: true,
                                            data: {
                                                ...popUpData,
                                                type: 'vendor',
                                                reminderType: 'PO_reminder',
                                                path: 'purchaseorders',
                                                path_id:
                                                    popUpData.purchaseorder_id,
                                            },
                                        })
                                    );
                                    setLoadingReminder('');
                                }}
                            >
                                <Clock
                                    size={25}
                                    color={
                                        row.original['cf_po_reminder'] ==
                                            'YES' ||
                                        row.original['cf_complaint_reminder'] ==
                                            'YES'
                                            ? '#ffff1a'
                                            : 'black'
                                    }
                                />
                            </button>
                        )}

                        <EditMenu align="left" className="relative inline-flex">
                            <li>
                                <span
                                    onClick={() => waModified(row.original)}
                                    className="font-medium text-sm text-slate-600 hover:text-indigo-600 flex py-1 px-3"
                                    style={{ cursor: 'pointer' }}
                                >
                                    WA Team Modified PO
                                </span>
                            </li>
                            <hr></hr>
                            <li>
                                <span
                                    onClick={() =>
                                        deliveryConfirmation(row.original)
                                    }
                                    className="font-medium text-sm text-slate-600 hover:text-indigo-600 flex py-1 px-3"
                                    style={{ cursor: 'pointer' }}
                                >
                                    Delivery Confirmation
                                </span>
                            </li>
                            <hr></hr>
                            <li>
                                <span
                                    onClick={() => sendChallan(row.original)}
                                    className="font-medium text-sm text-slate-600 hover:text-indigo-600 flex py-1 px-3"
                                    style={{ cursor: 'pointer' }}
                                >
                                    Send Challan
                                </span>
                            </li>
                            <hr></hr>
                            <li>
                                <span
                                    onClick={() =>
                                        sendAddressToVendor(row.original)
                                    }
                                    className="font-medium text-sm text-slate-600 hover:text-indigo-600 flex py-1 px-3"
                                    style={{ cursor: 'pointer' }}
                                >
                                    Send Address To Vendor
                                </span>
                            </li>
                            <hr></hr>
                            <li>
                                <span
                                    onClick={()=> handleHelp(row.original)}
                                    className="font-medium text-sm text-slate-600 hover:text-indigo-600 flex py-1 px-3 cursor-pointer"
                                >
                                    Help
                                </span>
                            </li>
                            <hr></hr>
                            <li>
                                <span
                                    onClick={()=> handleMergeAndSendToVendor(row.original)}
                                    className="font-medium text-sm text-slate-600 hover:text-indigo-600 flex py-1 px-3 cursor-pointer"
                                >
                                    Merge and Send to Vendor
                                </span>
                            </li>
                            <hr></hr>
                            <li>
                                <span
                                    onClick={()=> handleMergeAndSendToCustomer(row.original)}
                                    className="font-medium text-sm text-slate-600 hover:text-indigo-600 flex py-1 px-3 cursor-pointer"
                                >
                                    Merge and Send to Customer
                                </span>
                            </li>
                            <hr></hr>
                            <li>
                                <span
                                    onClick={()=> handelMergeAttachments(row.original)}
                                    className="font-medium text-sm text-slate-600 hover:text-indigo-600 flex py-1 px-3 cursor-pointer"
                                >
                                    Merge attachments
                                </span>
                            </li>
                            <hr></hr>
                            <li>
                                <span
                                    onClick={()=> handleBuyMore(row.original)}
                                    className="font-medium text-sm text-slate-600 hover:text-indigo-600 flex py-1 px-3 cursor-pointer"
                                >
                                    Buy More
                                </span>
                            </li>
                            <hr></hr>
                            <li>
                                <span
                                    onClick={()=> handleDoubt(row.original)}
                                    className="font-medium text-sm text-slate-600 hover:text-indigo-600 flex py-1 px-3 cursor-pointer"
                                >
                                    Have Doubt
                                </span>
                            </li>
                        </EditMenu>
                        {/* {
                         btnId == row.original.purchaseorder_id && purchaseOrderLoading ? <ClipLoader /> :   
                        <PrimaryButton onClick={(e) => {
                            e.stopPropagation()
                            convertBill(row.original)
                        }} >Convert to Bill</PrimaryButton>
                        } */}
                    </div>
                );
            },
        },
        // {
        //   Header: "SRNO",
        //   Cell: ({ row, data }) => {
        //     return 200 * (page - 1) + row.index + 1;
        //   },
        // },
        // {
        //   Header: "DATE",
        //   Cell: ({ row }) => {
        //     return moment(row.original.date).format("DD/MM/YYYY");
        //   },
        // },
        {
            Header: 'PURCHASE ORDER#',
            Cell: ({ row, data }) => {
                return (
                    <div
                        className={
                            row?.original?.has_attachment
                                ? 'underline text-blue-500 cursor-pointer'
                                : 'cursor-pointer'
                        }
                        onClick={(e) => {
                            e.stopPropagation();
                            setAttachmentData({
                                id: row.original.purchaseorder_id,
                                page: page,
                            });
                            setAttachmentModal(true);
                        }}
                    >
                        {row.original.purchaseorder_number}
                        <span className="text-[0.5rem]">
                            {row?.original?.cf_last_upload_dt}
                        </span>
                    </div>
                );
            },
            style: {
                width: '12%',
            },
        },
        {
            Header: 'QTY TAKA',
            accessor: 'cf_qty_taka',
            style: {
                width: '8%',
            },
        },
        {
            Header: 'QUALITY NAME',
            accessor: 'cf_quality_name',
        },
        {
            Header: 'VENDOR NAME',
            accessor: 'vendor_name',
            Cell:({row})=>{
                return(
                    <PhoneIconBox 
                        child={<span>{row?.original?.vendor_name}</span>}
                        green
                        blue
                        obj={{contact_id: row?.original?.vendor_id}}
                    />
                )
            },
        },
        {
            Header: 'BUYER NAME',
            Cell: ({ row }) => {
                return (
                    <div className="flex flex-col gap-4">                        
                        <PhoneIconBoxWithBuyer 
                            child={<h1>{row.original.cf_buyer_name}</h1>}
                            green
                            blue
                            obj={{
                                contact_type: 'customer',
                                name: row?.original?.cf_buyer_name,
                            }}
                        />
                        {row?.original?.['cf_po_note'] && (
                            <div className="flex">
                                <PrimaryBadge>
                                    {
                                        row?.original?.['cf_po_note']?.split(
                                            '---'
                                        )[0]
                                    }
                                </PrimaryBadge>
                                <span className="text-[0.5rem]">
                                    {
                                        row?.original?.['cf_po_note']?.split(
                                            '---'
                                        )[1]
                                    }
                                </span>
                            </div>
                        )}
                    </div>
                );
            },
            accessor: 'cf_buyer_name',
        },
        {
            Header: 'DATE',
            Cell: ({ row }) => {
                return (
                    <div className="flex flex-col">
                        <span
                            className="underline text-indigo-500 cursor-pointer"
                            onClick={(e) => {
                                e.stopPropagation();
                                setEditDateModalOpen(true);
                                setEditPoId(row.original.purchaseorder_id);
                            }}
                        >
                            Issue Date{' '}
                            {moment(row.original.date).format('DD/MM/YYYY')}
                        </span>
                        <span>
                            Delivery Date{' '}
                            {moment(row.original.delivery_date).format(
                                'DD/MM/YYYY'
                            )}
                        </span>
                    </div>
                );
            },
            style: {
                width: '20%',
            },
        },
        {
            Header: 'Brokerage',
            Cell:({row})=>{
                return(
                    <div className='flex justify-start'>
                    <SecondaryButton className={'p-1'}
                        onClick={(e)=>{
                            e.stopPropagation();
                            console.log('row',row?.original)
                            const obj ={
                                contact_type: 'customer',
                                name: row?.original?.cf_buyer_name,
                            }
                            
                            setShowQuarterlyBrokerageModal(true)
                            setPayloadData(obj)
                        }}
                    >
                        Quarterly Brokerage
                    </SecondaryButton>
                    </div>
                )
            }
        },
        {
            Header: 'RATE',
            accessor: 'cf_rate',
        },
        {
            Header: 'AMOUNT',
            accessor: 'total',
        },
    ];

    const handleNext = (e) => {
        e.preventDefault();
        setPage(page + 1);
    };

    const debouncedSearch = useCallback(
        _.debounce((search) => {
            let data = {};
            if (formik.values.search == 'vendor') {
                data['vendor_name_contains'] = search;
            } else {
                data[
                    `custom_field_${customIDs.purchase_custom_buyerName}_contains`
                ] = search;
            }

            dispatch(
                fetchPurchaseOrders({
                    ...data,
                    page: 1,
                    status: 'open',
                })
            );
        }, 300),
        [JSON.stringify(formik.values)]
    );
    return (
        <div className="p-4">
            <AdvanceSearchModal
                // formik={advanceSearchFormik}
                setAdvanceSearchData={setAdvanceSearchData}
                title="Advance Search"
                isOpen={showAdvanceSearch}
                setIsOpen={setShowAdvanceSearch}
            />
            <EditPurchaseModal
                title={'Edit Purchase Order'}
                setPurchaseModal={setPurchaseModal}
                viewPurchaseModal={viewPurchaseModal}
                data={editData}
            />
            <AttachmentModal
                viewAttachmentModal={viewAttachmentModal}
                setAttachmentModal={setAttachmentModal}
                data={attachmentData}
            />
            <EditDateModal
                editDateModalOpen={editDateModalOpen}
                setEditDateModalOpen={setEditDateModalOpen}
                editPoId={editPoId}
                setEditPoId={setEditPoId}
            />
            <ViewQuarterlyBrokerageModal 
                showQuarterlyBrokerageModal={showQuarterlyBrokerageModal}
                setShowQuarterlyBrokerageModal={setShowQuarterlyBrokerageModal}
                payloadData={payloadData}

            />
            <div className="mb-3 flex gap-2">
                <FormikSelectGroup
                    formik={formik}
                    label="Search Type"
                    name={`search`}
                    onChange={(selectedOption) => {
                        dispatch(
                            fetchPurchaseOrders({
                                page: page,
                                status: 'open',
                            })
                        );
                        formik.setFieldValue('search', selectedOption.value);
                    }}
                    options={generateOptions({
                        array: [
                            { label: 'Vendor', value: 'vendor' },
                            { label: 'Customer', value: 'customer' },
                        ],
                        labelField: 'label',
                        valueField: 'value',
                    })}
                    required
                />
                <div className="w-[20%] mt-auto">
                    <PrimaryButton
                        onClick={(e) => {
                            e.stopPropagation();
                            setShowAdvanceSearch(true);
                        }}
                        className={'w-full'}
                    >
                        Advance Search
                    </PrimaryButton>
                </div>
            </div>
            {advanceSearchData.hasMore && (
                <span className="text-red-500 my-3">
                    Warning: Found 200 or more purchase orders.
                </span>
            )}
            {!advanceSearchData.reset &&
                Object.values(advanceSearchData.data).map(
                    (purchaseOrders, i) => {
                        let countQtyTaka = purchaseOrders.reduce((acc, ele) => {
                            acc += Number(ele.cf_qty_taka);
                            return acc;
                        }, 0);

                        let modifiedPurchaseOrder = purchaseOrders.map((d) => ({
                            ...d,
                            className: poStatusStyle(d.status),
                        }));

                        return (
                            <div className="py-4" key={i}>
                                <TableWithHeadingAndGlobalSearch
                                    heading={`${purchaseOrders[0]?.cf_quality_name} || (${countQtyTaka})`}
                                    placeholder={`Search for ${
                                        formik.values.search == 'vendor'
                                            ? 'vendor Name'
                                            : 'customer Name'
                                    }`}
                                    data={modifiedPurchaseOrder}
                                    loading={loading}
                                    columns={cols}
                                    searchFunction={(search) => {
                                        debouncedSearch(search);
                                    }}
                                />
                            </div>
                        );
                    }
                )}
            {advanceSearchData?.reset && (
                <>
                    <TableWithHeadingAndGlobalSearch
                        heading={'Purchase Orders'}
                        placeholder={`Search for ${
                            formik.values.search == 'vendor'
                                ? 'vendor Name'
                                : 'customer Name'
                        }`}
                        data={purchaseOrdersData}
                        loading={loading}
                        columns={cols}
                        searchFunction={(search) => {
                            debouncedSearch(search);
                        }}
                    />
                    {!loading && (
                        <div className="mt-4 flex gap-3 justify-end">
                            {page > 1 && (
                                <PrimaryButton
                                    onClick={(e) => setPage(page - 1)}
                                >
                                    Previous
                                </PrimaryButton>
                            )}
                            {purchaseOrderPageContext.has_more_page && (
                                <PrimaryButton onClick={(e) => handleNext(e)}>
                                    Next
                                </PrimaryButton>
                            )}
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default ViewPurchaseOrder;
